// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bIH-x","footerButtons":"styles_footerButtons__mOlnZ","saveButton":"styles_saveButton__r3H6x"};